import React from 'react';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import { Link } from 'react-router-dom';
import { LockFill, UnlockFill } from 'react-bootstrap-icons';

class Part extends ChemComponent {
	constructor(props) {
		super(props);
		
		
		this.state = {
			part: {
				PART_ID: ''
			},
			editable: props.editable,
			partColumns: this.copyPartColumns(props.params.partId),
			markUpRate: 1.0,
			renderKey: 0
		}
	}	

	componentDidMount() {
		this.loadPart();
	}
	
	componentDidUpdate(prevProps) {
		if (this.props.params.partId !== prevProps.params.partId) {
			this.loadPart();
		}
	}
	
	copyPartColumns(partId) {
		var initPartColumns = this.copyColumns(partColumns);
		return initPartColumns;
	}

	loadPart(event) {
		var self = this;

		if (this.props.params.partId) {
			this.ajax({
				type: 'post',
				url: this.getConfig().host + '/Jobtrack/Search',
				data: { 
					__RequestVerificationToken: this.props.user.antiForgeryToken,
					entity: 'PARTS_VW',
					search: { Attribute: 'PART_ID', Operator: '=', LongValue: this.props.params.partId },
					pageNumber: -1,
					pageSize: -1
				}
			}).done(function (data) {
				if (data.Success) {					
					self.mergeState({
						part: data.Data[0],
						markUpRate: self.getNumeric(data.Data[0].RATE_PCT, 1),
						renderKey: self.state.renderKey + 1
					}, () => {
						if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
					});
				} else {
					self.showAlert('Server Error', data.Message);
				}			
			}).fail(function (jqXHR, textStatus, errorThrown) {
				self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
			});
		} else {
			this.ajax({
				type: 'post',
				url: this.getConfig().host + '/Jobtrack/Search',
				data: { 
					__RequestVerificationToken: this.props.user.antiForgeryToken,
					entity: 'MARK_UP_RATE',
					search: { Operator: 'and', Children: [
						{ Attribute: 'SHOP_ID', Operator: '=', LongValue: 1 },
						{ Attribute: 'END_DATE', Operator: 'is null' },
						{ Attribute: 'DELETE_FLAG', Operator: 'is null' },
						{ Attribute: 'VALID_FLAG', Operator: '=', StringValue: 'Y' }
					]},
					pageNumber: -1,
					pageSize: -1
				}
			}).done(function (data) {
				if (data.Success) {
					self.setState({
						part: { PART_ID: '(new)' },
						editable: self.state.editable,
						partColumns: self.copyPartColumns(self.props.params.partId),
						markUpRate: data.Data[0].RATE_PCT,
						renderKey: self.state.renderKey + 1
					}, () => {
						if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
					});
				} else {
					self.showAlert('Server Error', data.Message);
				}			
			}).fail(function (jqXHR, textStatus, errorThrown) {
				self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
			});
		}
	}
		
	onChange(accessor, value) {
		var part = this.copyObject(this.state.part);
		this.setByAccessor(part, accessor, value);
		// if this is a new part and there is a vendor price
		if (this.isNumeric(part.VENDOR_PRICE)) {
			// calculate unit cost
			this.setByAccessor(part, 'UNIT_COST', this.round(part.VENDOR_PRICE*this.state.markUpRate, 3));
		} else {
			this.setByAccessor(part, 'UNIT_COST', '');
		}
		this.mergeState({ part: part });
	}
	
	validatePart(event, columns, data) {
		return this.validate(columns, data);
	}

	onSubmit(event) {
		var self = this;
		var part = this.copyObject(this.state.part);
		var url;
		
		// set ID sequence if this is a new part
		if (this.props.params.partId) {
			url = this.getConfig().host + '/Home/Update';
		} else {
			url = this.getConfig().host + '/Home/Insert';
			part.PART_ID = 'shop_part_seq.nextval';
		}

		this.ajax({
			type: 'post',
			url: url,
			overlay: true,
			data: {
				__RequestVerificationToken: this.props.user.antiForgeryToken,
				entity: 'RECHARGES.SHOP_PART',
				data: part
			}
		}).done(function (data) {
			if (data.Success) {
				self.props.parent.showConfirmation(() => {
					var partId = self.props.params.partId || data.ID;
					var verb = self.props.params.partId ? 'updated' : 'added';
					return (<>
						Part <Link to={'/Jobtrack/Parts/' + partId}>{partId}</Link> {verb}.
					</>);
				});				
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}
	
	render() {		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', paddingBottom: '10px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
				  <Container fluid>
					<Row>
					  <Col>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>
							Material Part {this.state.part.PART_ID}&nbsp;&nbsp;
							{this.state.editable ? 
							  <UnlockFill style={{ cursor: 'pointer', marginTop: '-4px' }}
								onClick={() => this.mergeState({ editable: false })} /> : 
							  <LockFill style={{ cursor: 'pointer', marginTop: '-4px' }} 
								onClick={() => this.mergeState({ editable: true })} />}
						</div>
					  </Col>
					</Row>
					<Row>
					  <Col style={{ paddingBottom: '10px' }}>
						<ChemEdit parent={this} user={this.props.user} columns={this.state.partColumns} data={this.state.part}
							onChange={(accessor, value) => this.onChange(accessor, value)} renderKey={this.state.renderKey}
							validate={(event, columns, data) => this.validatePart(event, columns, data)}
							onSubmit={(event) => this.onSubmit(event)} editable={this.state.editable}>
							<Form.Group as={Row}>
							  <Col style={{ borderTop: '1px solid #eee', paddingTop: '5px' }}>
								{this.state.editable && <Button id="save" variant="warning" type="submit" className="float-end">Save</Button>}
							  </Col>
							</Form.Group>							
						</ChemEdit>
					  </Col>
					</Row>
				  </Container>
				</Col>
			  </Row>
			</Container>
		</>);
	}
}

const partColumns = [
	{ Header: 'Shop', accessor: 'SHOP_ID', type: 'select', row: 0, col: 0, required: true,
		options: { value: 'SHOP_ID', label: 'SHOP_NAME', entity: 'RECHARGES.PART_SHOP_SELECT_VW', order: 'SHOP_NAME' }},
	{ Header: 'Category', accessor: 'CATEGORY_ID', type: 'select', row: 0, col: 1, required: true,
		options: { value: 'CATEGORY_ID', label: 'CATEGORY_NAME', entity: 'RECHARGES.PART_CATEGORY_SELECT_VW', order: 'CATEGORY_NAME_SORT' }},
	{ Header: 'Part Name', accessor: 'PART_NAME', row: 0, col: 2, required: true },
	{ Header: 'Alt. Desc', accessor: 'ALT_DESC', row: 1, col: 0 },
	{ Header: 'Use Unit', accessor: 'UNIT_OF_MEASURE', row: 1, col: 1, required: true },
	{ Header: 'Recharge Cost $', accessor: 'UNIT_COST', row: 1, col: 2, editable: false },
	{ Header: 'Vendor', accessor: 'VENDOR_NAME', row: 2, col: 0, required: true },
	{ Header: 'Vendor Part #', accessor: 'VENDOR_PART', row: 2, col: 1 },
	{ Header: 'Vendor Price', accessor: 'VENDOR_PRICE', row: 2, col: 2, required: true },
	{ Header: 'Vendor Unit', accessor: 'VENDOR_UNIT', row: 3, col: 0, required: true },
	{ Header: 'Vendor Qty/Unit', accessor: 'VENDOR_UNIT_QTY', row: 3, col: 1, required: true },
	{ Header: 'Cross Reference', accessor: 'X_REF', row: 3, col: 2 },
	{ Header: 'Manufacturer Number', accessor: 'MANUF_NUM', row: 4, col: 0 },
	{ Header: 'Comments', accessor: 'COMMENTS', type: 'textarea', row: 4, col: 1 },
	{ Header: 'Inventory', accessor: 'STOCK_QTY', row: 4, col: 2 }
];

export default withRouter(Part);
